import React from 'react';
import './Teachers.css';
import { Row, Col } from 'react-bootstrap';

const Teachers: React.FC = () => {
  const teachers = [
    { name: 'Vaishanavi Chaturvedi', role: 'MBA (HR)', image: '/images/teachers/teacher1.jpeg' },
    { name: 'Pragya Singh', role: 'B.Ed., M.Ed.', image: '/images/teachers/teacher2.jpeg' },
    { name: 'Beena', role: 'B.Ed. (TET)', image: '/images/teachers/teacher3.jpeg' },
    { name: 'Shazia Anjum', role: 'B.A., B.Ed. (Persuing)', image: '/images/teachers/teacher4.jpeg' },
    { name: 'Sarika Dwivedi', role: 'MBA, B.Ed.', image: '/images/teachers/teacher5.jpeg' },
    { name: 'Jyoti Varshney', role: 'B.tech, B.Ed.', image: '/images/teachers/teacher6.jpeg' },
    { name: 'Mausami Rao', role: 'BA, B.Ed. (Persuing)', image: '/images/teachers/teacher7.jpeg' },
    { name: 'Rumi Singh', role: 'MA, B.Ed.', image: '/images/teachers/teacher8.jpeg' }
  ];

  return (
    <section className="teachers" id="teachers">
      <div className="container">
        <div className="teachers-header">
          <h2 className="section-title">Our Teachers</h2>
          <p className="section-subtitle">Meet our dedicated team of early childhood educators committed to nurturing young minds</p>
        </div>
        <div className="teachers-grid">
          <Row className="g-4">
            {teachers.map((teacher, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
                <div key={index} className="teacher-card">
                  <div className="teacher-image"><img src={teacher.image} alt={teacher.name} /></div>
                  <h3>{teacher.name}</h3>
                  <p className="teacher-role">{teacher.role}</p>
                  {/* <div className="teacher-social">
                    <a href="#facebook"><i className="fab fa-facebook"></i></a>
                    <a href="#twitter"><i className="fab fa-twitter"></i></a>
                    <a href="#instagram"><i className="fab fa-instagram"></i></a>
                  </div> */}
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </section>
  );
};

export default Teachers;
